import { Component, OnInit } from '@angular/core';
import { PermissionsService } from '../../../../Services/permissions.service';
import { TenantService } from '../../../../Services/tenant.service';
import { MatSidenavContainer } from '@angular/material/sidenav';
import { MatSlideToggle } from '@angular/material/slide-toggle';
import { FormsModule } from '@angular/forms';

@Component({
    selector: 'permissions',
    templateUrl: './permissions.component.html',
    styleUrls: ['./permissions.component.less'],
    imports: [MatSidenavContainer, MatSlideToggle, FormsModule]
})

export class PermissionsComponent implements OnInit {
    public blockUi: boolean = false;
    public tenant = this.tenantService.selectedTenant;
    public filterText = "";
    public users: any;
    public resultsCount = 0;
    private originalList: any;

    constructor(private permissionsService: PermissionsService,
        public tenantService: TenantService) { }

    public ngOnInit(): void {
        this.filterText = "";
        this.getTenantUsers();
    }

    public enableAccess(userId: string, checked: string): void {
        this.blockUi = true;
        this.permissionsService.enableAccess(this.tenant, checked, userId).subscribe(() => {
            this.blockUi = false;
        });
    }

    public filterUsers(): void {
        if (this.filterText == "" || this.filterText == undefined) {
            this.users = this.originalList;
        } else {
            this.users = this.originalList.filter(user => {
                let flag;
                for (let prop in user) {
                    flag = false;
                    flag = user[prop].toString().toLowerCase().indexOf(this.filterText.toLowerCase()) > -1;
                    if (flag) break;
                }
                return flag;
            });
        }
    }

    public getTenantUsers(): void {
        this.blockUi = true;
        this.permissionsService.getUsers(this.tenant)
            .subscribe(users => {
                if (users != null) {
                    this.users = users;
                    this.originalList = users.slice(0);
                    this.resultsCount = users.length;
                }
                this.blockUi = false;
            });
    }

    toggleTenantRestrict() {
        this.blockUi = true;
        this.permissionsService.restrictTenant(this.tenant, !this.tenant.RestrictTenant).subscribe(() => {
            this.blockUi = false;
            this.getTenantUsers();
        })
    }
}
